import React from "react";

/**
 * EmptyIllustration — #1618 (D440, D442). The engineering drawings from the
 * brand kit (`illustration/` in the brand repo), one per empty state, drawn
 * 160px square above the title. WebP at 2x (400px), converted from the
 * originals; never the PNGs. Placeholders only: no text or number is in any
 * drawing. Lazy and async, since an empty state sits below the fold more
 * often than not; the front door's hero is the eager one.
 */
export const ILLUSTRATIONS = {
  matches: {
    src: "/images/illustration/empty-matches.webp",
    alt: "An open blank scorebook with a pencil and a ball.",
  },
  training: {
    src: "/images/illustration/empty-training.webp",
    alt: "A set of stumps on a practice pitch with a ball beside them.",
  },
  squad: {
    src: "/images/illustration/empty-squad.webp",
    alt: "A team sheet on a clipboard with empty places for the players, and a ball.",
  },
};

export function EmptyIllustration({ name, style }) {
  const art = ILLUSTRATIONS[name];
  if (!art) return null;
  return (
    <img
      data-testid="empty-illustration"
      src={art.src}
      alt={art.alt}
      width={160}
      height={160}
      loading="lazy"
      decoding="async"
      style={{ width: 160, height: 160, objectFit: "contain", display: "block", ...style }}
    />
  );
}

export default EmptyIllustration;
